import { InputTableURLsTable } from '../../../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../../../../../baseComponents/TwinTable/types'
import BasePaymentMethodInfoTPV from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout/components/BasePaymentMethodInfoTPV'
import { SetEditDeleteModalTy } from '../../../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'

interface ModalPaymentMethodInfoSellTicketProps {
    setOpenModal: SetEditDeleteModalTy
    allRowData?: RowData
    inputTableURLs: InputTableURLsTable
    handleCloseModal?: () => void
}

const ModalPaymentMethodInfoSellTicket: React.FC<ModalPaymentMethodInfoSellTicketProps> = ({ setOpenModal, allRowData, inputTableURLs, ...rest }) => {
    const { t } = useTwinTranslation()
    return (
        <BasePaymentMethodInfoTPV {...{
            setOpenModal, allRowData, inputTableURLs, translations: { title: t('paymentDone', 'Pago realizado'), textButton: { send: t('sendTicket', 'Enviar Ticket'), gift: t('giftTicket', 'Ticket regalo'), print: t('printTicket', 'Imprimir Ticket') }, numOrderTitle: t('nTicket', 'Núm. Ticket') }, functionButtonsURLs: {
                send: '/api/app/order/tpv/sellTicket/sendSellTicketPDF', gift: '/api/app/order/tpv/sellTicket/getPrintSellTicketGift', print: '/api/app/order/tpv/sellTicket/getPrintSellTicket'
            }, ...rest
        }} downloadPdfUrl={'/api/app/order/tpv/sellTicket/getSellTicketPdf'} />
    )
}

export default ModalPaymentMethodInfoSellTicket